export const SET_LOADING = 'SET_LOADING';
export const SEARCH_NAME = 'SEARCH_NAME';
export const GET_CHAR = 'GET_CHAR';
export const GET_FAV = 'GET_FAV';
export const ADD_FAV = 'ADD_FAV';
export const REMOVE_FAV = 'REMOVE_FAV';
export const FILTER = 'FILTER';
export const ORDER = 'ORDER';